import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { ValidationService } from 'src/app/core/services/validation.service';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API } from 'src/app/core/constants';
import { API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input-gg';
const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

@Component({
  selector: 'app-contact-dialog',
  templateUrl: './contact-dialog.component.html',
  styleUrls: ['./contact-dialog.component.scss']
})
export class ContactDialogComponent implements OnInit {
  contactForm: FormGroup;
  userInfo: any;
  expoInfo: any;
  roomInfo: any;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  selectedCountry = 'US';
  assets_url:any;

  constructor(
    private matDialogRef: MatDialogRef<ContactDialogComponent>,
    private formBuilder: FormBuilder,
    private ngxLoader: NgxUiLoaderService,
    private commanSubscribeService: CommanSubscribeService,
    public toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public _data: any
  ) { }

  ngOnInit() {
    this.assets_url = environment.assets_url;
    this.userInfo = this.commanSubscribeService.userInfo;
    console.log(this._data, "data", this.userInfo);
    this.expoInfo = this._data.expoInfo;
    this.roomInfo = this._data.roomInfo
    this.buildcontactForm();
  }
  buildcontactForm() {
    if(this.userInfo && this.userInfo.country_code)
      this.selectedCountry = this.userInfo.country_code;
    this.contactForm = this.formBuilder.group({
      first_name: [{ value: this.userInfo.user_first_name, disabled: false }, Validators.required],
      last_name: [{ value: this.userInfo.user_last_name, disabled: false }, Validators.required],
      email: [{ value: this.userInfo.email, disabled: false }, [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
      phone_number: [{ value: this.userInfo.user_phone_number, disabled: this.userInfo.user_phone_number == '' ? false : false }, Validators.required],
      org_name: [{ value: '', disabled: false }, Validators.required],
    });
  }
  closeModal() {
    this.matDialogRef.close();
  }

  get businessPhoneValue() {
    return this.contactForm.controls['phone_number'];
  }

  sendDetails() {
    this.contactForm.markAllAsTouched();
    let inputData = this.contactForm.getRawValue();
    let dial_code = (inputData.phone_number && inputData.phone_number.dialCode) ? inputData.phone_number.dialCode : '';
    inputData.phone_number = (inputData.phone_number && inputData.phone_number.number) ? inputData.phone_number.number.replace(/\W+/g, '') : '';
    inputData.phone_number = dial_code + inputData.phone_number;
    if (this.contactForm.valid) {
      console.log("inputData", inputData)
      let contactInfo = {
        first_name: inputData.first_name,
        last_name: inputData.last_name,
        email: inputData.email,
        phone_number: inputData.phone_number,
        org_name: inputData.org_name,
      }
      let params = {
        startTime: new Date(),
        contact_details: contactInfo,
        is_session: 0,
        user_id: this.userInfo.id,
        expo_room_id: this.roomInfo.id,
        expo_id: this.expoInfo.id,
        event_id: this.expoInfo.event_id,
      }
      console.log("params", params);
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`
        },
        response: true,
        body: params
      }
      let url = CONST_AWS_API.START_VIDEO_ROOM_SESSION;
      API.post(environment.AWS_Cognito.apiName, url, data).then(response => {
        console.log("response", response);
        if (response.data.statusCode === '200') {
          this.toastr.success("Details saved successfully");
          this.closeModal();
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    }
  }
}
